import { DEFAULT_DESKTOP_GRID_COLUMNS, DEVICE_PIXEL_THRESHOLD, } from "@bracket/ui/const";
import styled from "styled-components";



export const Grid = styled.div<{ $columns?: string; $desktopColumns?: string; $debug?: boolean; }>`
	display: grid;
	grid-template-columns: ${props => props.$columns || "1fr"};
	@media(min-width: ${DEVICE_PIXEL_THRESHOLD}px) {
		grid-template-columns: ${props => props.$desktopColumns || "DEFAULT_DESKTOP_GRID_COLUMNS"};
	}
	${({ $debug }) => $debug && `border: 1px solid red!important;`}
`;
